import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Setup from "./common/Setup";
import Settings from "./common/Settings";
import MapFields from "./common/MapFields";
import classnames from "classnames";
import { Link } from "react-router-dom";
import MapValues from "./common/MapValues";
import {
  getMapperModels,
  getMapperModelId,
  postModelBasicMapping,
  addMapperFiles,
  successMapping,
  setMapperModelID,
  setErrorMapping,
  addMapperTemplate,
  getMapperTemplate,
  getMapperTemplates,
  deleteMapperTemplate,
  uploadTemplateError,
  getMapperValidation,
  setMapperValidationSuccess,
} from "../../../store/mapper/actions";
import { getCampaignSourcesList } from "../../../store/campaigns/sources/actions"
import { showInfoMessage } from "../../../helpers/utils";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class UploadWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeNext: false,
      activeTab: 1,
      activeTabVartical: 1,
      passedSteps: [1],
      passedStepsVertical: [1],
      navigation: [
        {
          name: "Setup",
          toggle_name: 1,
          icon: "bx bx-upload",
          status: true,
        },
        {
          name: "Settings",
          toggle_name: 2,
          icon: "bx bx-wrench",
          status: false,
        },
        {
          name: "Map fields",
          toggle_name: 3,
          icon: "bx bx-edit-alt",
          status: false,
        },
        {
          name: "Map values",
          toggle_name: 4,
          icon: "bx bx-badge-check",
          status: false,
        },
      ],
      files: [
        {
          path: "",
        },
      ],
      selectedFiles: [],
      modelData: {},
      prevModelData: {},
      mapData: {},
      saveTemplateStatus: false,
      templateName: "",
    };

    this.toggleTab.bind(this);
    this.toggleTabVertical.bind(this);
    this.successfullyUpload = this.successfullyUpload.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickSetNextActive = this.onClickSetNextActive.bind(this);
    this.setSelectedFiles = this.setSelectedFiles.bind(this);
    this.updateFiles = this.updateFiles.bind(this);
    this.updateMapData = this.updateMapData.bind(this);
    this.updateModelData = this.updateModelData.bind(this);
    this.onClickStartValidate = this.onClickStartValidate.bind(this);
    this.handleChangeTemplateName = this.handleChangeTemplateName.bind(this);
    this.handleSaveTemplateStatus = this.handleSaveTemplateStatus.bind(this);
    this.handleSetDefaultState = this.handleSetDefaultState.bind(this);
  }

  componentDidMount() {
    this.props.getMapperModels();
    this.props.getCampaignSourcesList({
      sizePerPage: 0,
    });
  }
  consol
  handleSetDefaultState = () => {
    this.setState({
      activeTab: 1,
      files: [
        {
          path: "",
        },
      ],
      currentFileName: "",
      modelData: {},
      mapData: null,
      prevFile: "",
      selectedFiles: [],
      templateName: "",
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.modelData !== this.state.modelData) {
      this.setState({ prevModelData: prevState.modelData });
    }

    if (prevProps.data !== this.props.data) {
      this.setState({ prevFile: prevProps.data });
    }
  }

  componentWillUnmount() {
    this.handleSetDefaultState();
    this.updateMapData({});
    this.props.getMapperModels();
    this.props.setMapperModelID([]);
    this.props.successMapping(false);
  }

  handleChangeTemplateName = name => {
    this.setState({
      templateName: name,
    });
  };

  handleSaveTemplateStatus = status => {
    this.setState({
      saveTemplateStatus: status,
    });
  };

  handleChangePlatform = platform => {
    this.setState({
      platform: platform,
    });
  }

  updateMapData = data => {
    let updated_mapData = {};

    for (let [key, value] of Object.entries(data)) {
      if (value !== "NO_MAPPED") {
        updated_mapData[key] = value;
      }
    }
    this.setState({ mapData: updated_mapData });
  };

  updateModelData = data => {
    this.setState({ modelData: data });
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        let modifiedSteps = [...this.state.passedSteps, tab];
        this.setState({
          activeTab: tab,
          passedSteps: modifiedSteps,
        });

        if (tab === 1) {
          if (this.state.files.length !== 0) {
            this.setState({ activeNext: true });
          }
        }
      }
    }
  }

  toggleTabVertical(tab) {
    if (this.state.activesTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        let modifiedSteps = [...this.state.passedStepsVertical, tab];
        this.setState({
          activeTabVartical: tab,
          passedStepsVertical: modifiedSteps,
        });
      }
    }
  }

  successfullyUpload = () => {
    this.handleSetDefaultState();
    this.updateMapData({});
    this.props.getMapperModels();
    this.props.setMapperModelID([]);
    this.props.successMapping(false);
  };

  updateFiles = data => {
    this.setState({ files: data });
  };

  onClickSetNextActive = active => {
    this.setState({ activeNext: active });
  };

  setSelectedFiles = files => {
    this.setState({ selectedFiles: files });
  };

  onClickStartValidate = (data_file, map_data, model, platform) => {
    let pt = platform;
    this.props.getMapperValidation(data_file.id, map_data, model, platform = !['3', 3].includes(this.state.modelData.id) ? pt : '');
  };

  onClickNext = active => {
    switch (active) {
      case 1:
        if (this.state.files.length !== 0) {
          this.props.addMapperFiles({ data: this.state.files[0] });
          this.toggleTab(active + 1);
        }
        break;
      case 2:
        if (this.state.files.length !== 0) {
          this.toggleTab(active + 1);

          if (this.state.modelData.id !== this.state.prevModelData?.id) {
            this.props.getMapperTemplates({
              content_type: this.state.modelData.id,
            });
            this.props.getMapperModelId({ id: this.state.modelData.id });
          }
        }
        break;
      case 3:
        if (this.state.saveTemplateStatus) {
          if (this.state.templateName.length > 3) {
            this.toggleTab(active + 1);
          } else {
            showInfoMessage(
              "Too short template name, length must be more than 3 characters"
            );
          }
        } else {
          this.toggleTab(active + 1);
        }
        break;
      case 4:
        if (this.state.saveTemplateStatus) {
          this.props.addMapperTemplate({
            name: this.state.templateName,
            mapper: this.state.mapData,
            content_type: this.state.modelData.id,
          });
        }
        if (!this.props.templateError) {
          this.props.postModelBasicMapping({
            map_data: this.state.mapData,
            file_id: this.props.data.id,
            model_id: this.state.modelData.id,
            ...(!['3', 3].includes(this.state.modelData.id) && { platform: this.state.platform })
          });
        }
        break;
      default:
        return this.toggleTab(1);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Upload widget | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Upload widget"
              link="/upload-widget"
            />

            <div className="checkout-tabs">
              <Row className="d-flex justify-content-center">
                <Col md="12" lg="10" xl="9" >
                  <div
                    className="wizard clearfix"
                    style={{ display: this.props.success && "none" }}
                  >
                    <div className="steps clearfix">
                      <ul>
                        {this.state.navigation.map((i, key) => (
                          <NavItem
                            key={key}
                            className={classnames({
                              current:
                                this.state.activeTab === i.toggle_name ||
                                this.state.activeTab > i.toggle_name,
                            })}
                          >
                            <NavLink
                              className={classnames({
                                active: this.state.activeTab === i.toggle_name,
                              })}
                              style={{ cursor: "default" }}
                            >
                              <span className="number">
                                <i
                                  className={`${i.icon} font-size-16`}
                                  style={{
                                    verticalAlign: "middle",
                                  }}
                                />
                              </span>{" "}
                              {i.name}
                            </NavLink>
                          </NavItem>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <Card>
                    <CardBody>
                      <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId={1}>
                          <Setup
                            onClickSetNextActive={this.onClickSetNextActive}
                            files={this.state.files}
                            updateFiles={this.updateFiles}
                            selectedFiles={this.state.selectedFiles}
                            setSelectedFiles={this.setSelectedFiles}
                          />
                        </TabPane>
                        <TabPane tabId={2}>
                          <Settings
                            file={this.state.files}
                            modelDataId={this.state.modelData.id}
                            onClickSetNextActive={this.onClickSetNextActive}
                            data={this.props.models}
                            updateModelData={this.updateModelData}
                            success={this.props.success}
                            activeTab={this.state.activeTab}
                            getMapperTemplates={this.props.getMapperTemplates}
                          />
                        </TabPane>
                        <TabPane tabId={3}>
                          <MapFields
                            handleChangeTemplateName={
                              this.handleChangeTemplateName
                            }
                            handleSaveTemplateStatus={
                              this.handleSaveTemplateStatus
                            }
                            deleteMapperTemplate={
                              this.props.deleteMapperTemplate
                            }
                            prevFile={this.state.prevFile}
                            getMapperTemplates={this.props.getMapperTemplates}
                            modelData={this.state.modelData}
                            saveTemplateStatus={this.state.saveTemplateStatus}
                            templateName={this.state.templateName}
                            uploadTemplateError={this.props.uploadTemplateError}
                            getMapperTemplate={this.props.getMapperTemplate}
                            templates={this.props.templates}
                            template={this.props.template}
                            selectedFiles={this.state.selectedFiles}
                            files={this.state.files}
                            onClickSetNextActive={this.onClickSetNextActive}
                            model={this.props.model}
                            fileData={this.props.data}
                            updateMapData={this.updateMapData}
                            mapData={this.state.mapData}
                            success={this.props.success}
                            activeTab={this.state.activeTab}
                            permissions={this.props.permissions}
                            sources_list={this.props.sources_list.results}
                            sources_loading={this.props.sources_loading}
                            handleChangePlatform={this.handleChangePlatform}
                          />
                        </TabPane>
                        <TabPane tabId={4}>
                          <MapValues
                            data={this.props.data}
                            mapData={this.state.mapData}
                            validationErrors={this.props.validationErrors}
                            validationProcess={this.props.validationProcess}
                            validationSuccess={this.props.validationSuccess}
                            activeTab={this.state.activeTab}
                            setMapperValidationSuccess={
                              this.props.setMapperValidationSuccess
                            }
                            success={this.props.success}
                            successfullyUpload={this.successfullyUpload}
                            addMappProcess={this.props.addMappProcess}
                          />
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Card>
                  {!this.props.success && (
                    <Row style={{ paddingBottom: "20px" }}>
                      <Col lg={12} align="left">
                        {this.state.activeTab === 4 &&
                          !this.props.validationSuccess && (
                            <button
                              type="button"
                              style={{
                                margin:
                                  this.state.activeTab !== 1 && "0 10px 0 0",
                              }}
                              className="btn btn-primary"
                              disabled={!this.state.activeNext}
                              onClick={() =>
                                this.onClickStartValidate(
                                  this.props.data,
                                  this.state.mapData,
                                  this.state.modelData,
                                  !['3', 3].includes(this.state.modelData.id) ? this.state.platform : ''
                                )
                              }
                            >
                              Validate
                            </button>
                          )}
                        <button
                          type="button"
                          style={{
                            margin: this.state.activeTab !== 1 && "0 10px 0 0",
                          }}
                          className="btn btn-primary"
                          disabled={!this.state.activeNext}
                          onClick={() => this.onClickNext(this.state.activeTab)}
                        >
                          {this.state.activeTab === 4 ? "Begin Import" : "Next"}
                        </button>
                        {this.state.activeTab !== 1 && (
                          <Link
                            to="#"
                            onClick={() => {
                              this.toggleTab(this.state.activeTab - 1);
                            }}
                          >
                            Previous
                          </Link>
                        )}
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

UploadWidget.propTypes = {
  permissions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  data: PropTypes.any,
  model: PropTypes.array.isRequired,
  models: PropTypes.any,
  success: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  addMappProcess: PropTypes.bool.isRequired,
  templateError: PropTypes.bool.isRequired,
  templates: PropTypes.any,
  template: PropTypes.any,
  validationErrors: PropTypes.any,
  validationSuccess: PropTypes.bool.isRequired,
  validationProcess: PropTypes.bool.isRequired,
  getMapperModels: PropTypes.func.isRequired,
  getMapperModelId: PropTypes.func.isRequired,
  postModelBasicMapping: PropTypes.func.isRequired,
  addMapperFiles: PropTypes.func.isRequired,
  successMapping: PropTypes.func.isRequired,
  setMapperModelID: PropTypes.func.isRequired,
  setErrorMapping: PropTypes.func.isRequired,
  addMapperTemplate: PropTypes.func.isRequired,
  getMapperTemplate: PropTypes.func.isRequired,
  getMapperTemplates: PropTypes.func.isRequired,
  deleteMapperTemplate: PropTypes.func.isRequired,
  uploadTemplateError: PropTypes.func.isRequired,
  getMapperValidation: PropTypes.func.isRequired,
  setMapperValidationSuccess: PropTypes.func.isRequired,
  getCampaignSourcesList: PropTypes.func.isRequired,
  sources_list: PropTypes.any,
  sources_loading: PropTypes.bool,
};

const mapStateToProps = state => ({
  data: state.Mapper.data,
  model: state.Mapper.model,
  models: state.Mapper.models,
  templates: state.Mapper.templates,
  template: state.Mapper.template,
  success: state.Mapper.success,
  error: state.Mapper.error,
  addMappProcess: state.Mapper.addMappProcess,
  templateError: state.Mapper.templateError,
  validationErrors: state.Mapper.validationErrors,
  validationProcess: state.Mapper.validationProcess,
  validationSuccess: state.Mapper.validationSuccess,
  permissions: state.User.permissions,
  sources_list: state.CampaignSourceList.data,
  sources_loading: state.CampaignSourceList.loading,
});

export default connect(mapStateToProps, {
  addMapperFiles,
  getMapperModels,
  getMapperModelId,
  postModelBasicMapping,
  setMapperModelID,
  setErrorMapping,
  successMapping,
  addMapperTemplate,
  getMapperTemplate,
  getMapperTemplates,
  deleteMapperTemplate,
  uploadTemplateError,
  getMapperValidation,
  setMapperValidationSuccess,
  getCampaignSourcesList
})(withRouter(UploadWidget));
